/* eslint-disable react-hooks/exhaustive-deps */
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ThemProvider from "./context/ContextFile";
import {
  FeaturesProvider,
  ListingProvider,
  PaymentProvider,
} from "@/providers";
import { routes } from "./utils";
import { Suspense } from "react";
import QueryProvider from "./providers/QueryCientProvider";
// import { startTransition } from "react";

// Tailwind CSS Loader component
const Loader = () => (
  <div className="flex flex-col items-center justify-center h-screen gap-5">
    <img
      className="h-auto w-36 md:w-44" // Responsive sizes
      src="/image/fly-inn-logo.svg"
      alt="Fly Inn Logo"
    />
    <div className="text-2xl text-bold">
      {" "}
      Please Wait while we load your data!
    </div>
  </div>
);

function App({ children }) {
  return (
    <PaymentProvider>
      <QueryProvider>
        <ListingProvider>
          <FeaturesProvider>
            <ThemProvider>
              {children}
              <BrowserRouter>
                <Suspense fallback={<Loader />}>
                  <Routes>
                    {routes.map(({ path, element }, index) => (
                      <Route
                        key={index}
                        path={path}
                        element={
                          <Suspense fallback={<Loader />}>{element}</Suspense>
                        }
                      />
                    ))}
                  </Routes>
                </Suspense>
              </BrowserRouter>
            </ThemProvider>
          </FeaturesProvider>
        </ListingProvider>
      </QueryProvider>
    </PaymentProvider>
  );
}

export default App;
